import React from "react";
import { Rating } from "react-simple-star-rating";

class Category extends React.Component {
  pushVendorDetails = (id, days) => {
    localStorage.setItem("mechanic_id", id);
    this.props.props.history.push({
      pathname: "/multiVendor/categoryDetails",
    });
  };

  render() {
    return (
      <>
        {this.props.garages.map((item) => (
          <div
            className='categoryMultiVendor'
            onClick={() => this.pushVendorDetails(item.id)}>
            {item.discount !== 0 && (
              <div className='discountMultiVendor'>
                %{item.discount} تخفیف شما
              </div>
            )}
            <div className='imgVendors'>
              <img src={item.image} alt='pic' />
              {item.kachar_suggests && (
                <span className='kachar_suggests'>
                  <img src='/public/assets/icons/kachar01.svg' alt='pic' />
                </span>
              )}
            </div>
            <div className='categoryMultiVendorDetails'>
              <div className='nameCategory'>{item.name}</div>
              <div className='ratingCategory'>
                <Rating ratingValue={item.rate * 20} readonly={true} />
              </div>
              <div className='Servicestype'>
                <img src='/public/assets/icons/repair222.svg' alt='pic' />
                <span>{`${
                  item.type === "both"
                    ? "خدمات سیار و ثابت"
                    : item.type === "static"
                    ? "خدمات ثابت"
                    : item.type === "dynamic"
                    ? "خدمات سیار"
                    : ""
                }`}</span>
              </div>
              <div className='serviceCategory'>
                <img src='/public/assets/icons/Vector.svg' alt='pic' />
                <span>{item.service !== null && item.service.title}</span>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }
}
export default Category;
